export const gallery = [
  {
    image: '/launchpad/stories/primex-finance/app-1-2.png',
  },
  {
    image: '/launchpad/stories/primex-finance/app-2-2.png',
  },
];

export const introductionBenefits = [
  {
    id: 'introductionBenefits-1',
    item: (
      <span className="font-normal">No minimum amount requirements for Lenders and Farmers</span>
    ),
  },
  {
    id: 'introductionBenefits-2',
    item: <span className="font-normal">ZERO interface swap fees</span>,
  },
  {
    id: 'introductionBenefits-3',
    item: <span className="font-normal">Automated (limit) swaps</span>,
  },
  {
    id: 'introductionBenefits-4',
    item: (
      <span className="font-normal">
        Unlimited number of tokens available for leverage, including memecoins and AI agents not
        listed on CEXs
      </span>
    ),
  },
  {
    id: 'introductionBenefits-5',
    item: (
      <span className="font-normal">Position management with Take-Profit/Stop-Loss on DEXs</span>
    ),
  },
  {
    id: 'introductionBenefits-6',
    item: <span className="font-normal">Passive yield as Lenders</span>,
  },
  {
    id: 'introductionBenefits-7',
    item: <span className="font-normal">Primex Rewards Program</span>,
  },
];

export const keyFeatures = [
  {
    id: 'trading-interface',
    item: (
      <span className="font-normal">
        <a
          href="https://app.primex.finance/#/trade"
          target="_blank"
          className="font-medium underline text-base-text-blue"
        >
          A trading Interface
        </a>
        &nbsp;for spot DEXs with leveraged, TP/SL, limit orders and position management
      </span>
    ),
  },
  {
    id: 'lending-interface',
    item: (
      <span className="font-normal">
        <a
          href="https://app.primex.finance/#/buckets"
          target="_blank"
          className="font-medium underline text-base-text-blue"
        >
          A lending interface
        </a>
        &nbsp;for passive investors
      </span>
    ),
  },
  {
    id: 'yield-farming',
    item: (
      <span className="font-normal">
        Access to&nbsp;
        <a
          href="https://app.primex.finance/#/farming"
          target="_blank"
          className="font-medium underline text-base-text-blue"
        >
          DeFi yield farming strategies
        </a>
      </span>
    ),
  },
  {
    id: 'rwas-access',
    item: <span className="font-normal">Retail access to institutional RWAs</span>,
  },
  {
    id: 'pricepulse-miniapp',
    item: (
      <span className="font-normal">
        The&nbsp;
        <a
          href="https://t.me/Primex_PricePulse_Bot?start=315027970"
          target="_blank"
          className="font-medium underline text-base-text-blue"
        >
          PricePulse Telegram MiniApp
        </a>
        &nbsp;that offers engaging price prediction games and promotions for partner projects
      </span>
    ),
  },
];

export const problemsSolves = [
  {
    id: 'problemsSolves-1',
    item: (
      <span className="font-normal">
        Lack of High Leverage Opportunities: Enabling yield farmers to maximize returns on a variety
        of DeFi protocols made possible by under-collateralized borrowing.
      </span>
    ),
  },
  {
    id: 'problemsSolves-2',
    item: (
      <span className="font-normal">
        Automation in DeFi: Introducing flexible position management and a unified portfolio concept
        tailored for sophisticated yield farmers.
      </span>
    ),
  },
  {
    id: 'problemsSolves-3',
    item: (
      <span className="font-normal">
        Low entry barriers: Providing access to leveraging RWAs, LSTs, LRTs, and DEX LP tokens with
        no minimum amount requirements.
      </span>
    ),
  },
  {
    id: 'problemsSolves-4',
    item: (
      <span className="font-normal">
        Limited assets and pairs: Expanding the range of assets and trading pairs for margin trading
        beyond what is typically available on CEXs and perps DEXs.
      </span>
    ),
  },
  {
    id: 'problemsSolves-5',
    item: (
      <span className="font-normal">
        Centralized trade execution: Eliminating centralized trade execution to ensure true
        decentralization in DeFi.
      </span>
    ),
  },
  {
    id: 'problemsSolves-6',
    item: (
      <span className="font-normal">
        User experience gaps: Addressing usability issues to make DeFi more accessible and
        intuitive.
      </span>
    ),
  },
];

export const marketTraction = [
  {
    id: 'funding',
    item: (
      <span className="font-normal">
        $6.6M+ Raised: Successfully raised funding to support development and growth.
      </span>
    ),
  },
  {
    id: 'margin-trading',
    item: (
      <span className="font-normal">
        Margin Trading Interface for leveraged trading on DEXs, supporting 4 chains, more than 30
        DEXs, and 298 markets.
      </span>
    ),
  },
  {
    id: 'yield-farming',
    item: (
      <span className="font-normal">
        Yield Farming Interface Introduced for leveraged yield farming for top assets like those by
        Lido, Renzo, Ether.Fi, Frax, Ondo, Paxos, Threshold, and more.
      </span>
    ),
  },
  {
    id: 'perpetual-futures',
    item: (
      <span className="font-normal">
        Launched Primex perpetual futures trading as a new functionality for Traders, powered
        Orderly Network
      </span>
    ),
  },
  {
    id: 'partnerships',
    item: (
      <span className="font-normal">
        35+ Strategic Partnerships and Integrations: Collaborated with chains, wallets,
        infrastructure providers, token issuers, and others.
      </span>
    ),
  },
  {
    id: 'token-launch-partners',
    item: (
      <span className="font-normal">
        Token Launch Partners include top auditing firms (Halborn, Hacken, Omniscia), launchpads
        (Fjord, Tokensoft, etc.), and media platforms (Cointelegraph, Cryptorank).
      </span>
    ),
  },
  {
    id: 'pricepulse-miniapp',
    item: (
      <span className="font-normal">
        Primex PricePulse Telegram Mini App: Launched a game with more than 1M total users.
      </span>
    ),
  },
  {
    id: 'grants',
    item: (
      <span className="font-normal">
        Grants Awarded: Received Uniswap-Arbitrum and Arbitrum LTIPP grants.
      </span>
    ),
  },
  {
    id: 'fully-audited',
    item: (
      <span className="font-normal">
        Fully audited by top firms including Halborn, Quantstamp and Resonance.
      </span>
    ),
  },
];

export const businessModel = [
  {
    id: 'protocol-fee',
    item: <span className="font-normal">Protocol Fee, paid when opening a position</span>,
  },
  {
    id: 'leverage-fee',
    item: <span className="font-normal">Leverage Fee for using Lender liquidity</span>,
  },
  {
    id: 'listing-fee',
    item: <span className="font-normal">Listing Fee for adding new trading pairs</span>,
  },
  {
    id: 'withdrawal-fee',
    item: (
      <span className="font-normal">
        Withdrawal Fee, a percentage of deposits withdrawn by Lenders
      </span>
    ),
  },
  {
    id: 'rwas',
    item: <span className="font-normal">RWAs, interface and yield fees</span>,
  },
  {
    id: 'yield-farming-fee',
    item: (
      <span className="font-normal">
        Yield Farming Fee, charge a portion of profit from exclusive permissioned yield farming
        strategies (including RWAs)
      </span>
    ),
  },
];
